(function () {
  var sliderDepsRequested = false;
  var sliderInitBound = false;
  var sliderArrowIcon =
    '<svg width="29" height="10" viewBox="0 0 29 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.5328 4.77275C21.8118 3.63873 20.3415 2.7109 18.9321 1.71635C18.5866 1.47378 18.3494 1.03109 18.2342 0.636912C18.1868 0.467112 18.6204 -0.024095 18.7424 0.00622644C19.1964 0.0971907 19.6436 0.303376 20.0366 0.539883C22.1709 1.81338 24.2781 3.11114 26.4193 4.37251C26.67 4.51805 27.1104 4.60295 27.3679 4.50592C28.4249 4.10568 28.8043 4.55444 28.9669 5.39131C29.1363 6.2585 28.6146 6.63449 27.7609 6.87706C26.1211 7.33794 24.495 7.84128 22.8756 8.34461C21.2901 8.83582 19.7181 9.36948 18.1258 9.84249C17.6989 9.96984 17.2111 9.95165 16.7436 10.0002C16.5742 9.09052 17.1094 8.64783 17.7802 8.33249C19.2641 7.64116 20.7751 6.98622 22.3877 6.2585C14.8599 6.14328 7.45408 6.02806 -0.00597099 5.91284C-0.0466252 4.79095 0.590291 4.37857 1.46436 4.38464C3.18538 4.40283 4.89964 4.53625 6.61389 4.63934C8.69403 4.76669 10.7809 5.00926 12.8611 5.02139C16.1405 5.03352 19.4132 4.89404 22.6926 4.8152C22.862 4.8152 23.0314 4.79701 23.5193 4.76669L23.5328 4.77275Z" fill="currentColor"></path></svg>';

  function normalizeUrl(url) {
    if (!url) return '';
    return url.replace(/[?#].*$/, '').replace(/\/+$/, '');
  }

  function initCustomVariantButtons() {
    var buttonGroups = document.querySelectorAll('.custom-variant-buttons');
    if (!buttonGroups.length) return;

    buttonGroups.forEach(function (group) {
      var buttons = group.querySelectorAll('.custom-variant-button[data-url]');
      if (!buttons.length || group.dataset.yanaaVariantReady === 'true') return;
      group.dataset.yanaaVariantReady = 'true';

      var currentUrl = normalizeUrl(window.location.href);
      var activeSet = false;

      buttons.forEach(function (btn) {
        if (normalizeUrl(btn.dataset.url) === currentUrl) {
          btn.classList.add('active');
          activeSet = true;
        }
      });

      if (!activeSet && buttons[0]) {
        buttons[0].classList.add('active');
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          buttons.forEach(function (item) {
            item.classList.remove('active');
          });
          btn.classList.add('active');
          if (btn.dataset.url) window.location.href = btn.dataset.url;
        });
      });
    });
  }

  var slickDesktopMql = window.matchMedia('(min-width: 750px)');

  function dispatchGallerySlideChanged(slideEl) {
    if (!slideEl) return;
    var viewer = document.querySelector('product-gallery');
    if (!viewer) return;
    viewer.dispatchEvent(
      new CustomEvent('slideChanged', {
        detail: { currentElement: slideEl }
      })
    );
  }

  function getSlickStash(jq, slider) {
    var stashId = 'yanaa-slick-stash-' + (slider.attr('id') || 'gallery');
    var $stash = jq('#' + stashId);
    if (!$stash.length) {
      $stash = jq('<div>', { id: stashId, class: 'yanaa-slick-stash visually-hidden', 'aria-hidden': 'true' });
      slider.parent().append($stash);
    }
    return $stash;
  }

  function restoreStashedSlides(jq, slider) {
    var stashId = 'yanaa-slick-stash-' + (slider.attr('id') || 'gallery');
    var $stash = jq('#' + stashId);
    if (!$stash.length) return;
    $stash.children().detach().appendTo(slider);
  }

  function prepareSliderForSlick(jq, slider) {
    restoreStashedSlides(jq, slider);
    var $stash = getSlickStash(jq, slider);

    slider.children('.product__media-item').each(function () {
      if (window.getComputedStyle(this).display === 'none') {
        jq(this).detach().appendTo($stash);
      }
    });
  }

  function destroyProductSlider(jq, slider) {
    if (!slider.length) return;
    restoreStashedSlides(jq, slider);
    if (!slider.hasClass('slick-initialized')) return;

    var gallery = document.querySelector('media-gallery');
    if (gallery && typeof gallery.unbindSlickParallax === 'function') {
      gallery.unbindSlickParallax();
    }
    slider.off('afterChange.yanaaGallery');
    slider.slick('unslick');
  }

  function initProductSlider() {
    if (!slickDesktopMql.matches) return;
    if (typeof window.jQuery === 'undefined' || !window.jQuery.fn || !window.jQuery.fn.slick) return;

    var jq = window.jQuery;
    var slider = jq('.product__media-list');
    if (!slider.length) return;

    if (slider.hasClass('slick-initialized')) return;

    prepareSliderForSlick(jq, slider);

    if (!slider.children('.product__media-item').length) {
      restoreStashedSlides(jq, slider);
      return;
    }

    slider.slick({
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="custom-arrow custom-prev">' + sliderArrowIcon + '</button>',
      nextArrow: '<button type="button" class="custom-arrow custom-next">' + sliderArrowIcon + '</button>'
    });

    slider.on('afterChange.yanaaGallery', function (_event, _slick, currentIndex) {
      var currentEl =
        slider.find('.slick-slide').not('.slick-cloned').eq(currentIndex).get(0) ||
        slider.find('.slick-current').get(0);
      dispatchGallerySlideChanged(currentEl);
    });

    dispatchGallerySlideChanged(slider.find('.slick-current').get(0));

    var gallery = document.querySelector('media-gallery');
    if (gallery && typeof gallery.bindSlickParallax === 'function') {
      gallery.bindSlickParallax(jq, slider);
    } else {
      document.dispatchEvent(new CustomEvent('yanaa:slick-gallery-ready', { detail: { slider: slider.get(0) } }));
    }
  }

  function ensureProductSliderDeps() {
    if (!slickDesktopMql.matches) return;

    if (sliderDepsRequested) {
      if (window.__yanaaProductSliderDepsReady) initProductSlider();
      return;
    }

    sliderDepsRequested = true;

    function loadDeps() {
      if (!window.YanaaDeps || typeof window.YanaaDeps.load !== 'function') return;
      window.YanaaDeps
        .load({
          key: 'yanaa-product-slider',
          styles: [
            { id: 'yanaa-slick-css', href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css' },
            { id: 'yanaa-slick-theme-css', href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css' }
          ],
          scripts: [
            'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js',
            'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js'
          ]
        })
        .then(function () {
          window.__yanaaProductSliderDepsReady = true;
          initProductSlider();
        });
    }

    loadDeps();
    document.addEventListener('yanaa:deps-loader-ready', loadDeps, { once: true });
  }

  function teardownMobileSlider(jq) {
    var slider = jq ? jq('.product__media-list') : null;
    if (jq && slider && slider.length) {
      destroyProductSlider(jq, slider);
      slider.find('.slick-slide').removeClass('slick-slide slick-current slick-active');
    }
    stripSlickSlideClassesForMobileScroll();
  }

  function queueGalleryInit() {
    if (!document.querySelector('.product__media-list')) return;

    if (!slickDesktopMql.matches) {
      stripSlickSlideClassesForMobileScroll();
      return;
    }

    ensureProductSliderDeps();
  }

  function bindGlobalListeners() {
    if (sliderInitBound) return;
    sliderInitBound = true;

    var onBreakpointChange = function () {
      if (slickDesktopMql.matches) {
        ensureProductSliderDeps();
        return;
      }

      if (typeof window.jQuery !== 'undefined') {
        teardownMobileSlider(window.jQuery);
      } else {
        stripSlickSlideClassesForMobileScroll();
      }
    };

    if (typeof slickDesktopMql.addEventListener === 'function') {
      slickDesktopMql.addEventListener('change', onBreakpointChange);
    } else if (typeof slickDesktopMql.addListener === 'function') {
      slickDesktopMql.addListener(onBreakpointChange);
    }

    document.addEventListener('shopify:section:load', function () {
      initCustomVariantButtons();
      queueGalleryInit();
    });
  }

  function stripSlickSlideClassesForMobileScroll() {
    if (slickDesktopMql.matches) return;
    document
      .querySelectorAll('.product__media-list:not(.slick-initialized) .slick-slide')
      .forEach(function (slide) {
        slide.classList.remove('slick-slide', 'slick-current', 'slick-active');
      });
  }

  function refreshDesktopGallery() {
    if (!slickDesktopMql.matches) return;
    if (!window.__yanaaProductSliderDepsReady || !window.jQuery?.fn?.slick) return;
    var jq = window.jQuery;
    var slider = jq('.product__media-list');
    if (!slider.length) return;
    destroyProductSlider(jq, slider);
    initProductSlider();
  }

  window.yanaaRefreshDesktopGallery = refreshDesktopGallery;

  function init() {
    initCustomVariantButtons();
    queueGalleryInit();
    bindGlobalListeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
